<script setup lang="ts">
import { AuthLoginForm } from '@/modules/auth/components';
definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
  layout: 'default',
});

useHead({
  title: 'Login',
});
</script>
<template>
  <v-container class="d-flex mx-auto align-items-center fill-height login-container">
    <AuthLoginForm data-testid="login-form" />
  </v-container>
</template>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .login-container {
    display: block !important;
    padding-top: 48px;
  }
}
</style>
